
import HeroSection from '../../components/feature/HeroSection';
import FeaturedActivities from '../../components/feature/FeaturedActivities';
import HotelsSection from '../../components/feature/HotelsSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import TrustSection from '../../components/feature/TrustSection';
import PersonalizationQuiz from '../../components/feature/PersonalizationQuiz';
import NewsletterSection from '../../components/feature/NewsletterSection';
import ContactSection from '../../components/feature/ContactSection';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />
      <HeroSection />
      <FeaturedActivities />
      <HotelsSection />
      <TestimonialsSection />
      <TrustSection />
      <PersonalizationQuiz />
      <NewsletterSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
